import React from 'react';
import { Observer } from '@poa/state';

function getBecome(become) {
  if (typeof become === 'object' && become !== null) return JSON.stringify(become);
  else return become;
}

function HistoryItem({ history }) {
  return (
    <div className="account-history__item">
      <button className="account-history__refresh refresh-btn">
        <svg className="icon icon-refresh" />
      </button>
      <div className="account-history__head">
        <div className="account-history__title">{history.fullName}</div>
        <div className="account-history__date">{history.datetime}</div>
      </div>
      <div className="account-history__body">
        <table className="account-history__table">
          <thead>
            <tr>
              <th />
              <th>Было</th>
              <th>Стало</th>
            </tr>
          </thead>
          <tbody>
            {history.changes.map(change => (
              <tr key={change.field}>
                <td>{change.field}</td>
                <td>{change.was}</td>
                <td>{getBecome(change.become)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function ProfileTabHistory({ state }) {
  return (
    <div className="tab active" data-tab="questionnaire">
      <div className="tab__inner">
        <div className="account-history">
          <Observer>
            {() =>
              state.model.history.map((history, index) => (
                <HistoryItem key={index} history={history} />
              ))
            }
          </Observer>
        </div>
      </div>
    </div>
  );
}
